import { ref, Ref } from 'vue'

// 改变视图时标志位
export const viewChangeCallback: Ref<Array<(flag: boolean) => void>> = ref([]);
